
<div class="products">
  <v-row dense wrap align="center" class="productsIntro">
    <v-col cols="12" md="6">
      <h1 class="display-1 pageTitle">{{ $t("PRODUCTS_HEADER") }}</h1>
      <div :class="['productsDescription', {expanded: descriptionExpanded}]">
        <div id="productsDescriptionText" class="subheading" v-html="$t('PRODUCTS_TEXT')"></div>
        <span v-if="!descriptionExpanded" class="descriptionEllipsis" aria-hidden="true">...</span>
        <button v-if="!descriptionExpanded" type="button" class="descriptionToggle"
                aria-expanded="false"
                aria-controls="productsDescriptionText"
                @click="descriptionExpanded = true">
          {{ $t('PRODUCTS_READ_MORE') }}
        </button>
      </div>
    </v-col>
    <v-col cols="12" md="6" class="productsDiscount" :class="{'d-none d-md-block': !hasCoupons}">
      <ShopNavigationActions :step="3" class="desktopNavigation d-none d-md-flex"/>
      <StickyDiscountBanner :get-boundary="getBoundary" v-if="hasCoupons" :suppress-floating="configuring"/>
    </v-col>
    <v-col v-if="false" cols="12" class="whiteCard christmas">
      <v-row wrap row>
        <v-col class="iconFlex">
          <img :src="christmasImage" class="christmasImage"/>
        </v-col>
        <v-col class="textFlex">
          <p class="text"><b>Tipp: </b>Weihnachten steht vor der Tür! Profitieren Sie von unserer großen Auswahl an <b>Geschenkprodukten</b> weiter unten auf der Seite, um Ihren Liebsten eine Freude zu machen.</p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <!-- Product Category Tabs -->
  <v-row wrap v-if="availableCategories.length > 0" class="category-row">
    <v-col cols="12">
      <div class="category-tabs" role="group" :aria-label="$t('PRODUCTS_HEADER')">
        <v-btn depressed :class="['category-chip', {'v-tab--active': selectedCategoryIndex === 0}]"
               :aria-pressed="selectedCategoryIndex === 0 ? 'true' : 'false'"
               @click="selectedCategoryIndex = 0">
          <v-icon v-if="false" left small>mdi-view-grid</v-icon>
          {{ $t('PRODUCTS_ALL_CATEGORIES') }}
        </v-btn>
        <v-btn v-for="(category, index) in availableCategories" :key="category.id" depressed
               :class="['category-chip', {'highlight-chip': category.highlight, 'v-tab--active': selectedCategoryIndex === index + 1}]"
               :aria-pressed="selectedCategoryIndex === index + 1 ? 'true' : 'false'"
               @click="selectedCategoryIndex = index + 1">
          <v-icon v-if="category.iconName" left small>{{ category.iconName }}</v-icon>
          {{ category.name }}
        </v-btn>
      </div>
    </v-col>
  </v-row>

  <v-row wrap class="layout product-row" justify="center">
    <v-col v-for="product in filteredProducts" :key="product.id" class="product-col">
      <ProductDiscountBadge class="d-none d-md-inline-block" :price="product.price" :instead-of="product.setPriceInsteadOf"/>
      <v-card :class="{productCard: true, highlight: product.highlight}"
              @click.native="openProductOnMobile($event, product)">
        <span v-if="product.highlight" class="productHighlight" aria-hidden="true"></span>
        <router-link :to="`/product/${product.id}`" class="productImage" :aria-label="product.name">
          <v-img
            :src="product.imageUrl"
            class="productImageContent"
            contain
            lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAN4AAADjCAMAAADdXVr2AAAAA1BMVEX///+nxBvIAAAASElEQVR4nO3BMQEAAADCoPVPbQdvoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOA8W9AAHiq1isAAAAAElFTkSuQmCC"></v-img>
        </router-link>
        <div class="productInfo">
          <v-card-title class="productHeader">
            <ProductDiscountBadge class="d-md-none" :price="product.price" :instead-of="product.setPriceInsteadOf"/>
            <router-link :to="`/product/${product.id}`" class="productTitleLink">{{ product.name }}</router-link>
          </v-card-title>
          <div class="productBody">
            <div v-if="product.descriptionDisplay === descriptionModes.BULLETS" class="productContents">
              <ul v-if="product.highlightedPoints && product.highlightedPoints.length"
                  class="bulletPoints highlightedPoints" role="list">
                <li v-for="(point, index) in product.highlightedPoints" :key="index">
                  <v-icon class="bulletIcon primary white--text" aria-hidden="true">mdi-check</v-icon>
                  <span>{{ point }}</span>
                </li>
              </ul>
              <ul v-if="product.summaryPoints && product.summaryPoints.length"
                  class="bulletPoints summaryPoints grey--text text--darken-2" role="list">
                <li v-for="(point, index) in product.summaryPoints" :key="index">
                  <v-icon class="bulletIcon" color="grey darken-2" aria-hidden="true">mdi-check</v-icon>
                  <span>{{ point }}</span>
                </li>
              </ul>
            </div>
            <div v-else-if="product.shortDescription" class="productContents" v-html="product.shortDescription"></div>

            <ProductActions :price="product.price" :instead-of="product.setPriceInsteadOf"
                            :from="product.detailedConfigurationSurcharge > 0"
                            :label="$t('BUTTON_ADD_PRODUCT')" icon="add"
                            @configure="startConfiguration(product)"/>
          </div>
        </div>

      </v-card>
    </v-col>
  </v-row>

  <ProductConfigurationDialog ref="configurationDialog" v-if="configurationProduct" v-model="configuring" :product="configurationProduct"
                              @addedToBasket="onAddedToBasket" @error="onConfigurationError"/>
  <v-snackbar :value="!!configurationError" @input="configurationError = null" color="error" :timeout="5000">
    {{ configurationError }}
  </v-snackbar>

  <!-- Show All Products Button -->
  <v-row v-if="selectedCategory !== null" justify="center" class="show-all-row">
    <v-col cols="auto">
      <v-btn large outlined color="primary" @click="showAllProducts">
        {{ $t('PRODUCTS_SHOW_ALL') }}
      </v-btn>
    </v-col>
  </v-row>
</div>
